import { useTranslation } from 'react-i18next'
import { ContentSection } from '@/features/settings/components/content-section'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { useTheme } from '@/context/theme-provider'

export function ThemeSettingsPage() {
  const { t } = useTranslation('common')
  const { theme, setTheme } = useTheme()

  return (
    <ContentSection
      title={t('settings.theme')}
      desc={t('settings.themeDescription')}
    >
      <div className="space-y-2">
        <Label htmlFor="operators-theme-select">{t('settings.theme')}</Label>
        <Select
          value={theme}
          onValueChange={(value) => {
            if (value === 'light' || value === 'dark' || value === 'system') {
              setTheme(value)
            }
          }}
        >
          <SelectTrigger id="operators-theme-select" className="w-[min(100%,280px)]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="light">{t('settings.themeLight')}</SelectItem>
            <SelectItem value="dark">{t('settings.themeDark')}</SelectItem>
            <SelectItem value="system">{t('settings.themeSystem')}</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </ContentSection>
  )
}
